import React from "react";
import "./Donate.css"
import NavBar from "../NavBar/NavBar";
import Footer from "../Footer/Footer";

class Donate extends React.Component {
    render() {
        return (
            <div>
                <NavBar/>
                <p className="empty-content">This area of the website is currently under construction. Please contact Rae Anne McLaughlin at rae@kidsinseats.org to make a financial contribution.</p>
                <Footer/>
            </div>
        )
    }
}

export default Donate;